export default {"src":"/_next/static/media/enerflo-embedded-loan-apps-icon.136f64ef.svg","height":74,"width":76};